import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import googleAnalytics from '../../../utils/googleAnalytics';
import classes from './Element.module.css';

const Element = ({ link, label, selected }) => {
  const hub = useSelector((state) => state.hub.hub);
  const { sectionName } = useParams();

  return (
    <Link
      to={link}
      className={`${classes.sectionOption} ${selected ? classes.selected : ''}`}
      onClick={() => {
        googleAnalytics({
          event: 'page_view',
          page_title: `${sectionName}-${label}`,
          section_title: hub.name,
        });
      }}
    >
      {label}
    </Link>
  );
};

Element.propTypes = {
  link: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
};

Element.defaultProps = { selected: false };

export default Element;
